/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClientStatusHistory } from './ClientStatusHistory';
import {
    ClientStatusHistoryFromJSON,
    ClientStatusHistoryFromJSONTyped,
    ClientStatusHistoryToJSON,
    ClientStatusHistoryToJSONTyped,
} from './ClientStatusHistory';

/**
 * 
 * @export
 * @interface ClientStatusCounselorResponse
 */
export interface ClientStatusCounselorResponse {
    /**
     * 
     * @type {Array<ClientStatusHistory>}
     * @memberof ClientStatusCounselorResponse
     */
    statusHistory: Array<ClientStatusHistory>;
}

/**
 * Check if a given object implements the ClientStatusCounselorResponse interface.
 */
export function instanceOfClientStatusCounselorResponse(value: object): value is ClientStatusCounselorResponse {
    if (!('statusHistory' in value) || value['statusHistory'] === undefined) return false;
    return true;
}

export function ClientStatusCounselorResponseFromJSON(json: any): ClientStatusCounselorResponse {
    return ClientStatusCounselorResponseFromJSONTyped(json, false);
}

export function ClientStatusCounselorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientStatusCounselorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'statusHistory': ((json['statusHistory'] as Array<any>).map(ClientStatusHistoryFromJSON)),
    };
}

export function ClientStatusCounselorResponseToJSON(json: any): ClientStatusCounselorResponse {
    return ClientStatusCounselorResponseToJSONTyped(json, false);
}

export function ClientStatusCounselorResponseToJSONTyped(value?: ClientStatusCounselorResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statusHistory': ((value['statusHistory'] as Array<any>).map(ClientStatusHistoryToJSON)),
    };
}

